<style>
.table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.table__container--panel p {
  font-size: 12px;
}
.table__container--filter {
  font-size: 12px;
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
      >description</v-icon>

      <v-icon
        @click="$emit('removeFilters')"
        title="Usuń filtry"
      >cancel</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 85%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    tableTitle: "HistoryChangesTable",
    date_now: new Date(),
    filter: "",
    numberAll: 0,
    numberFiltered: 0
  }),
  components: {
    AgGridVue,
    ExportTableData,
    Buttons: {
      template:
        '<span><v-icon small title="Pokaż szczegóły" @click="invokeShow">info</v-icon></span>',
      computed: {
        activeModals() {
          return this.$store.getters.getModalsList;
        }
      },
      methods: {
        show(title) {
          if(this.activeModals.indexOf(title) == -1) {
            this.$store.commit("addModal", title);
            this.$modal.show(title);
          }
        },
        invokeShow() {
          let payload = {
            uid: this.params.data.id,
            verbose: true
          };
          this.$store.dispatch("getHistoryChange", payload).then(res => {
            if(res.status == 200) {
              this.show("HistoryChangesDetails");
              this.$root.$emit("historyDetailLoaded", res.data);
            }
          });
        }
      }
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onFilterModified: this.filteredNumber,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        rowSelection: "multiple",
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          lessThan: "Mniejsza niż",
          greaterThan: "Większa niż",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "",
        cellRendererFramework: "Buttons",
        minWidth: 50,
        width: 50
      },
      {headerName: "ID", field: "id", sort: "asc"},
      {headerName: "Warstwa", field: "layer_name"},
      {headerName: "Operacja", field: "operation"},
      {
        headerName: "Czas",
        field: "time",
        cellRenderer: date => {
          return new Date(date.value).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          });
        }
      },
      {headerName: "Użytkownik", field: "username"}
    ];
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    loadData() {
      this.$store.dispatch("getHistory", true).then(res => {
        if(res.status == 200) {
          this.numberAll = res.data.data.length;
          this.numberFiltered = this.numberAll;
          this.gridOptions.api.setRowData(res.data.data);
        }
      });
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    refreshGrid() {
      if(this.gridOptions && this.gridOptions.api) {
        this.loadData();
      }
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    removeFilters() {
      this.gridOptions.api.setFilterModel(null);
      this.filteredNumber();
      this.filter = "";
    }
  },
  mounted() {
    this.$on("removeFilters", this.removeFilters);
    this.$root.$on("refreshGrid", this.refreshGrid);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/history/HistoryChangesTable.vue